<template>
    <gcmcn-layout
        title="MONITORING"
        class="monitoring-view"
        id="monitoring-layout"
    >

        <div :style="{'min-height': `calc(100vh - ( ${$store.getters.pageHeight}px))`, padding: '30px 15px'}">
            <ns-loader
                ref="nsLoader"
                :to-load="toLoad"
                :scoped="false"
                @dataFetched="onDataFetched"
                :fetchTimer="2000"
            >
                <ns-loader-spinner slot="loader"></ns-loader-spinner>
                <template slot="content">
                    <el-tabs
                        class="gcmcn-tabs"
                        style="margin-top: 30px;"
                        v-model="activeName"
                    >
                        <el-tab-pane label="Feeds" name="feeds">
                            <h2 class="monitoring-feed-title">Failed Feeds</h2>
                            <div v-if="failedFeeds.length > 0">
                                <monitoring-resources
                                    v-for="feed in failedFeeds"
                                    :resource="feed"
                                    :key="feed.uid"
                                    :reconfigurations="reconfigurations"
                                    :monitorData="monitorForFeed(feed)"
                                    @setRunningResource="setRunningResource"
                                >
                                </monitoring-resources>
                            </div>
                            <div v-else class="list-empty" style="margin-top: 20px;">No failed feeds retrieved</div>
                            <h2 class="monitoring-feed-title">Running feeds</h2>
                            <div v-if="runningFeeds.length > 0">
                                <monitoring-resources
                                    v-for="feed in runningFeeds"
                                    :resource="feed"
                                    :key="feed.uid"
                                    :reconfigurations="reconfigurations"
                                    :monitorData="monitorForFeed(feed)"
                                    @setFailedResource="setFailedResource"
                                >
                                </monitoring-resources>
                            </div>
                            <div v-else class="list-empty" style="margin-top: 20px;">No running feeds retrieved</div>
                        </el-tab-pane>
                        <el-tab-pane label="Channels" name="channels">
                            <h2 class="monitoring-feed-title">Failed Channels</h2>
                            <div v-if="failedChannels.length > 0">
                                <monitoring-resources
                                    v-for="channel in failedChannels"
                                    :resource="channel"
                                    :key="channel.uid"
                                    :reconfigurations="reconfigurations"
                                    :monitorData="monitorForChannel(channel)"
                                    :resource-is-feed="false"
                                    @setRunningResource="setRunningResource"
                                >
                                </monitoring-resources>
                            </div>
                            <div v-if="failedChannels.length === 0" class="list-empty" style="margin-top: 20px;">
                            No failed channel retrieved</div>
                            <h2 class="monitoring-feed-title">Running channels</h2>
                            <div v-if="runningChannels.length > 0">
                                <monitoring-resources
                                    v-for="channel in runningChannels"
                                    :resource="channel"
                                    :key="channel.uid"
                                    :reconfigurations="reconfigurations"
                                    :monitorData="monitorForChannel(channel)"
                                    :resource-is-feed="false"
                                    @setFailedResource="setFailedResource"
                                >
                                </monitoring-resources>
                            </div>
                            <div v-else class="list-empty" style="margin-top: 20px;">No running channels retrieved</div>
                        </el-tab-pane>
                    </el-tabs>
                </template>
            </ns-loader>
        </div>
    </gcmcn-layout>
</template>

<script>
import GcmcnLayout from '../../partials/gcmcn-layout.vue';
import NsLoader from 'fundation-app-vuejs/src/components/partials/ns-vue-loader';
import NsLoaderSpinner from '../../partials/ns-loader-template.vue';
import MonitoringTable from './monitoring-table.vue';
import MonitoringResources from './monitoring-resources.vue';
import {mapGetters} from 'vuex';
export default {

    components: {
        NsLoaderSpinner,
        NsLoader,
        GcmcnLayout,
        MonitoringTable,
        MonitoringResources
    },

    props: {

    },

    data: function(){
        return {
            contentLoaded: false,
            feeds: [],
            failedFeedsUid: [],
            channels: [],
            failedChannelsUid: [],
            feedMonitors: [],
            channelMonitors: [],
            reconfigurations: [],
            activeName: 'feeds',
        };
    },

    computed: {
        ...mapGetters([
            'userIsAtLeastAdmin',
            'userIsEntityAdmin',
            'administrableEntitiesUids'
        ]),
        toLoad (){
            let modelToFetch = [
                {
                    name: 'feeds',
                    model: 'feeds',
                    filters: {
                        archived: false,
                        status__in: ['RUNNING', 'STARTING'],
                        ordering: 'display_name',
                    }
                },
                {
                    name: 'channels',
                    model: 'channels',
                    filters: {
                        archived: false,
                        status: 'RUNNING',
                        ordering: 'display_name',
                    }
                },
            ];
            if(this.userIsAtLeastAdmin){
                modelToFetch.push(
                    {
                        name: 'reconfigurations',
                        model: 'reconfiguration',
                        filters: {
                            status__in: 'PENDING,RUNNING',
                        }
                    },
                    {
                        name: 'feedAdminMonitors',
                        model:'feedAdminMonitors',
                        filters: {
                            archived: false
                        }
                    },
                    {
                        name: 'channelAdminMonitors',
                        model: 'channelAdminMonitors',
                        filters: {
                            archived: false
                        }
                    },
                );
            }else if(this.userIsEntityAdmin()){
                modelToFetch.push(
                    {
                        name: 'reconfigurations',
                        model: 'reconfiguration',
                        filters: {
                            status__in: 'PENDING,RUNNING',
                        }
                    },
                    {
                        name: 'feedAdminMonitors',
                        model:'feedAdminMonitors',
                        filters: {
                            archived: false
                        }
                    },
                    {
                        name: 'channelAdminMonitors',
                        model: 'channelAdminMonitors',
                        filters: {
                            archived: false
                        }
                    },
                    {
                        name: 'feedManagerMonitors',
                        model: 'feedManagerMonitors',
                        filters: {
                            archived: false
                        }
                    },
                    {
                        name: 'channelManagerMonitors',
                        model: 'channelManagerMonitors',
                        filters: {
                            archived: false
                        }
                    },
                );
            }else{
                modelToFetch.push(
                    {
                        name: 'feedManagerMonitors',
                        model: 'feedManagerMonitors',
                        filters: {
                            archived: false
                        }
                    },
                    {
                        name: 'channelManagerMonitors',
                        model: 'channelManagerMonitors',
                        filters: {
                            archived: false
                        }
                    }
                );
            }
            return modelToFetch;
        },
        runningChannels(){
            return this.channels.filter(channel => !this.failedChannelsUid.includes(channel.uid));
        },
        failedChannels(){
            return this.channels.filter(channel => this.failedChannelsUid.includes(channel.uid));
        },
        runningFeeds(){
            return this.feeds.filter(feed => !this.failedFeedsUid.includes(feed.uid));
        },
        failedFeeds(){
            return this.feeds.filter(feed => this.failedFeedsUid.includes(feed.uid));
        }
    },

    mounted: function(){

    },

    methods: {
        monitorForFeed(feed) {
            let monitorData = this.feedMonitors.find(monitor => monitor.feed_uid === feed.uid);
            if (monitorData) {
                return monitorData;
            }
            else {
                return {};
            }
        },
        monitorForChannel(channel) {
            let monitorData = this.channelMonitors.find(monitor => monitor.channel_uid === channel.uid);
            if (monitorData) {
                return monitorData;
            }
            else {
                return {};
            }
        },
        async onDataFetched (res){
            this.$set(this, 'feeds', res.feeds);
            this.$set(this, 'channels', res.channels);
            if(this.userIsAtLeastAdmin){
                this.$set(this, 'reconfigurations', res.reconfigurations);
                this.$set(this, 'feedMonitors', res.feedAdminMonitors);
                this.$set(this, 'channelMonitors', res.channelAdminMonitors);
            }else if(this.userIsEntityAdmin()){
                this.$set(this, 'reconfigurations', res.reconfigurations);
                await this.setMonitorData(res);
            }else{
                this.$set(this, 'feedMonitors', res.feedManagerMonitors);
                this.$set(this, 'channelMonitors', res.channelManagerMonitors);
            }
            this.contentLoaded = true;
        },
        setMonitorData(res){
            /*
              If userIsEntityManager we want to get :
              - adminMonitors models currentUser can administrate.
              - managerMonitors models in currentUser's scopes without the ones he can administrate.
            */
            let feedAdminMonitors = res.feedAdminMonitors.filter(
                monitor =>
                    this.administrableEntitiesUids.includes(monitor.scopes.entity_uid)
            );
            let channelAdminMonitors = res.channelAdminMonitors.filter(
                monitor =>
                    this.administrableEntitiesUids.includes(monitor.scopes.entity_uid)
            );
            let feedManagerMonitors = res.feedManagerMonitors.filter(
                monitor =>
                    !this.administrableEntitiesUids.includes(monitor.scopes.entity_uid)
            );
            let channelManagerMonitors = res.channelManagerMonitors.filter(
                monitor =>
                    !this.administrableEntitiesUids.includes(monitor.scopes.entity_uid)
            );
            let feedMonitors = [...feedAdminMonitors, ...feedManagerMonitors];
            let channelMonitors = [...channelAdminMonitors, ...channelManagerMonitors];
            this.$set(this, 'feedMonitors', feedMonitors);
            this.$set(this, 'channelMonitors', channelMonitors);
        },
        setRunningResource(data){
            if(data.isFeed){
                if(this.failedFeedsUid.includes(data.resourceUid)){
                    let uidIndex = this.failedFeedsUid.indexOf(data.resourceUid);
                    this.failedFeedsUid.splice(uidIndex, 1);
                }
            }else{
                if(this.failedChannelsUid.includes(data.resourceUid)){
                    let uidIndex = this.failedChannelsUid.indexOf(data.resourceUid);
                    this.failedChannelsUid.splice(uidIndex, 1);
                }
            }
        },
        setFailedResource(data){
            if(data.isFeed){
                if(!this.failedFeedsUid.includes(data.resourceUid)){
                    this.failedFeedsUid.push(data.resourceUid);
                }
            }else{
                if(!this.failedChannelsUid.includes(data.resourceUid)){
                    this.failedChannelsUid.push(data.resourceUid);
                }
            }
        },
    },
};
</script>

<style lang="scss">
.monitoring-view {
    padding: 30px;
    .monitoring-feed-title {
        font-weight: 600;
        font-size: 18px;
    }
}
</style>




// WEBPACK FOOTER //
// src/components/page/Monitoring/index.vue